import React, { useRef, useState } from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import { Link as ChakraLink, LinkProps, Image, Flex, Grid, GridItem , Text, Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure} from "@chakra-ui/react";
import { HashLink } from "react-router-hash-link";
import { finished_works1, finished_works2, finished_works3, sketches } from "../info/finished_works";
import ImageItem from "./ImageItem";


export default function Artwork() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [ modalSrc, setModalSrc ] = useState("");
  const [ modalDesc, setModalDesc ] = useState("");



  return (
    <Flex
      h="100vh"
      justifyContent={"flex-start"}
      alignItems="center"
      flexDir={"column"}
    >
      <Grid
        templateAreas={{
          base: `"nav"
              "main"`,
        }}
        gridTemplateRows={{ base: "5rem 1fr" }}
        gridTemplateColumns={{ base: "1fr" }}
        h="100vh"
        w="60vw"
        py="1rem"
        overflow={"hidden"}
      >
        <GridItem
          area={"main"}
          overflowY={"scroll"}
          overflowX={"hidden"}
          display={"flex"}
          flexDir={"column"}
          alignItems={"center"}
          px="2rem"
        >
          {/* *********** FINISHED WORKS ****************/}
          <div id="art">
            <Text
              variant={"subHeader"}
              textAlign="left"
              lineHeight="90%"
              color="darkestgrey"
              
            >
              Artwork
            </Text>
            <Text variant={"type"} my="1rem">
              Please click on image to see enlarged version! <br></br>
              (Images may take a second to load)
            </Text>
            <Flex justifyContent={"space-between"}>
              <Flex flexDir={"column"} gap="4" w="32%">
                {finished_works1.map((p, key) => (
                  <ImageItem
                    src={p.src}
                    desc={p.desc}
                    key={key}
                    setModalDesc={setModalDesc}
                    setModalSrc={setModalSrc}
                    onOpen={onOpen}
                  />
                ))}
              </Flex>
              <Flex flexDir={"column"} gap="4" w="32%">
                {finished_works2.map((p, key) => (
                  <ImageItem
                    src={p.src}
                    desc={p.desc}
                    key={key}
                    setModalDesc={setModalDesc}
                    setModalSrc={setModalSrc}
                    onOpen={onOpen}
                  />
                ))}
              </Flex>
              <Flex flexDir={"column"} gap="4" w="32%">
                {finished_works3.map((p, key) => (
                  <ImageItem
                    src={p.src}
                    desc={p.desc}
                    key={key}
                    setModalDesc={setModalDesc}
                    setModalSrc={setModalSrc}
                    onOpen={onOpen}
                  />
                ))}
              </Flex>
            </Flex>
          </div>
        </GridItem>
      </Grid>

      <Modal isOpen={isOpen} onClose={onClose} isCentered size={"lg"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader></ModalHeader>
          <ModalCloseButton />
          <ModalBody
            display="flex"
            flexDir={"column"}
            justifyContent={"center"}
          >
            <Image objectFit="contain" maxH={"75vh"} src={modalSrc} />
            <Text variant={"type"} mt="1rem" textAlign={"center"}>
              {modalDesc}
            </Text>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Flex>
  );
}
